import * as faceapi from "face-api.js";

export async function getFaceCenter(
  img: HTMLImageElement
): Promise<{ x: number; y: number } | null> {
  const detection = await faceapi.detectSingleFace(
    img,
    new faceapi.TinyFaceDetectorOptions()
  );

  if (!detection) return null; // kein Gesicht gefunden

  const box = detection.box; // { x, y, width, height }
  return {
    x: box.x + box.width / 2,
    y: box.y + box.height / 2,
  };
}